import ListCyclicSchedule from "./List";
import CreateCyclicSchedule from "./Create";
import EditCyclicSchedule from "./Edit";
import RecyclingIcon from "@mui/icons-material/Recycling";
import permissions from "app/permissions";
import { StudentServicePath, CYCLIC_SCHEDULE } from "utils/constants";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <RecyclingIcon />,
  name: StudentServicePath + CYCLIC_SCHEDULE,
  title: "Циклични дисциплини",
  list: <ListCyclicSchedule />,
  create: <CreateCyclicSchedule />,
  edit: <EditCyclicSchedule />,
  createPermission: permissions.canManageCyclicSchedules,
  editPermission: permissions.canManageCyclicSchedules,
  permission: permissions.canPreviewCyclicSchedules,
};
